import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  path?: string;
  image?: string;
}

const DEFAULT_OG_IMAGE = 'https://athnxgym.com/og-image.png';

export default function SEO({
  title = 'AthnxGym | Run Your Gym Like a Tech',
  description = 'Stop depending on manufacturers and expensive service calls. AthnxGym gives private gym owners the knowledge and tools to run their own equipment.',
  path = '/',
  image = DEFAULT_OG_IMAGE,
}: SEOProps) {
  const url = `https://athnxgym.com${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="AthnxGym" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
